import { render, staticRenderFns } from "./pbi-basket-comparison.page.vue?vue&type=template&id=905480a6"
import script from "./pbi-basket-comparison.page.vue?vue&type=script&lang=ts"
export * from "./pbi-basket-comparison.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports